// extracted by mini-css-extract-plugin
module.exports = {"Layout":"yZ0qI896"};